import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../../../../Support/classNames';
import {format} from 'date-fns';
import {Snippet} from '../../../../../Models/Snippet';
import {ReportData} from '../CompareReportPresenter';
import {ReportField, reportFieldToFormattedValue, reportFieldToLabel} from '../../Models/ReportField';
import {tableColumnTitles} from '../Utils/TableColumnTitles';
import {FeatureFlags} from '../../../../../FeatureFlags';

interface OwnProps {
    reportData: ReportData;
    className?: string;
}

export const CompareTable: FunctionComponent<OwnProps> = ({reportData, className}) => {
    const snippets = [...reportData.snippets].sort((a, b) => {
        return a.publicWorkout.executedAt.getTime() - b.publicWorkout.executedAt.getTime();
    });

    const baseFields: ReportField[] = [
        ReportField.ElapsedTime,
        ReportField.TraveledDistance,
        ReportField.AveragePower,
        ReportField.AverageSplit,
        ReportField.AveragePeakForce,
        ReportField.AverageDriveTime,
        ReportField.AverageRecoverTime,
        ReportField.AverageEnergyPerStroke,
        ReportField.AverageStrokeLength,
        ReportField.AverageRelativePeakForcePosition,
    ];

    const rSquaredFields: ReportField[] = [
        ReportField.AverageRSquaredTotalStroke,
        ReportField.AverageRSquaredPrePeak,
        ReportField.AverageRSquaredPostPeak,
    ];

    const reportFields = FeatureFlags.extendedStrokeAnalyzer
        ? [...baseFields, ...rSquaredFields]
        : baseFields;

    return (
        <div className={classNames('row', className)}>
            <div className="col-12">
                <div className="card progresstable">
                    <table className="table">
                        <thead>
                            <tr>
                                <th></th>
                                {tableColumnTitles(snippets).map((title) => (
                                    <th>{title}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {reportFields.map((reportField) => (
                                <tr>
                                    <td>{reportFieldToLabel(reportField)}</td>
                                    {snippets.map((snippet) => (
                                        <td>{reportFieldToFormattedValue(reportField, snippet)}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
